module.exports = __webpack_public_path__ + "img/empty.a2c34142.png";